"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT_SANS_ORI = void 0;
const FONT_SANS_ORI = exports.FONT_SANS_ORI = 'SansOri, SansOriFallback, sans-serif';
